import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeFilterItemDiscount,
  reportFilterItemDiscountSelector,
  reportItemDiscountOptionsSelector,
} from '../../../state';
import { Discount } from '../../../types';
import { MultiSelect } from '../../selects';

const ItemDiscountFilter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const discountResource = useSelector(reportItemDiscountOptionsSelector);
  const { data, loading } = discountResource;
  const discount = useSelector(reportFilterItemDiscountSelector);

  const disabled = !discountResource.loaded;

  const handleChange = useCallback(
    (value: Discount[]) => {
      dispatch(changeFilterItemDiscount(value));
    },
    [dispatch]
  );

  const options = useMemo(() => data, [data]);

  return (
    <MultiSelect
      label={t('toolbar.labels.item_discount')}
      propDesc="description"
      options={options}
      disabled={disabled}
      value={discount}
      onChange={handleChange}
      loading={loading}
    />
  );
};

export default ItemDiscountFilter;
